import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';

class CustomBoxHeader extends PureComponent {
	_refreshOnClick = (e) => {
		const {refreshOnClick} = this.props;
		refreshOnClick(e);
	};

	_searchOnChange = (e) => {
		const {searchOnChange} = this.props;
		if(e.target.value.trim().length || e.target.value === '') searchOnChange(e);
	};

	render() {
		console.log('box header render');
		const {refreshIconClass, refreshText, searchIconClass, searchPlaceholder} = this.props;

		return (
			<div className="row">
				<div className="col-xs-8 col-sm-8 col-md-4 col-lg-4">
					<div className="input-group">
						<span className="input-group-addon">
							<i className={searchIconClass}/>
						</span>
						<input type="text" className="form-control" placeholder={searchPlaceholder} onChange={this._searchOnChange}/>
					</div>
				</div>
				<div className="col-xs-4 col-sm-4 col-md-8 col-lg-8 text-right">
					<button className="btn btn-primary btn-inverse" onClick={this._refreshOnClick}>
						<i className={`${refreshIconClass} hidden-sm hidden-md hidden-lg`} aria-hidden="true"/>
						<span className="hidden-xs">{refreshText}</span>
					</button>
				</div>
			</div>
		)
	}
}

CustomBoxHeader.defaultProps = {
	refreshIconClass: 'fa fa-refresh',
	refreshText: 'Refresh',
	searchIconClass: 'fa fa-search',
	searchPlaceholder: 'Search'
};

CustomBoxHeader.propTypes = {
	refreshOnClick: PropTypes.func.isRequired,
	searchOnChange: PropTypes.func.isRequired,
	refreshIconClass: PropTypes.string,
	refreshText: PropTypes.string,
	searchIconClass: PropTypes.string,
	searchPlaceholder: PropTypes.string,
};

export default CustomBoxHeader;
